export default function getIsContestOngoing(DISPLAY_START_DATE: string, DISPLAY_END_DATE: string) {
  const currentDate = new Date();

  return currentDate >= new Date(DISPLAY_START_DATE) && currentDate <= new Date(DISPLAY_END_DATE);
}

export function canOpenLatestContest(DISPLAY_START_DATE: string, DISPLAY_END_DATE: string) {
  const currentDate = new Date();
  return currentDate >= new Date(DISPLAY_START_DATE) && currentDate <= new Date(DISPLAY_END_DATE);
}
